export interface Amount {
  amount: string;
  currencyCode: string;
}

export interface SubscriptionDiscountPercentageValue {
  percentage: number;
}

export interface SubscriptionDiscountFixedAmountValue {
  amount: Amount;
}

export interface DiscountAllocationDiscount {
  id: string;
  recurringCycleLimit?: number;
  rejectionReason?: string;
  title: string;
  type: 'MANUAL' | 'CODE_DISCOUNT';
  usageCount?: number;
  value:
    | SubscriptionDiscountPercentageValue
    | SubscriptionDiscountFixedAmountValue;
}

export interface DiscountAllocation {
  amount: Amount;
  discount: DiscountAllocationDiscount;
}

export interface SubscriptionLine {
  currentPrice: Amount;
  discountAllocations?: DiscountAllocation[];
  quantity: number;
  customAttributes?: Array<{
    key: string;
    value: string;
  }>;
}

export const isPercentageDiscount = (
  discount:
    | SubscriptionDiscountFixedAmountValue
    | SubscriptionDiscountPercentageValue,
): discount is SubscriptionDiscountPercentageValue =>
  (discount as SubscriptionDiscountPercentageValue).percentage !== undefined;
